var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "480px",
    viewBox: "0 0 800 480",
    style: {
      enableBackground: "new 0 0 800 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#00B140"
    },
    width: 800,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 800,
    height: 240
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M246.6631012,113.816391 c-25.9803162,3.9373093-91.8203278,10.1230011-117.5086365,5.9057388l5.0197296,12.0918198 c42.5151062-3.9372711,83.2593079,9.8426666,121.0523682-4.4993591L246.6631012,113.816391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M145.9850006,143.3433228 c-16.2404175-4.7793274-43.1071167-32.6195297-47.5348206-49.4925232 c12.6948471,8.7161789,43.1052246,19.9655914,54.0296631,18.8414078 c-3.5436707,2.5309982-12.4014282,9.2787094-19.1920624,10.1230011 C136.5375824,129.0031128,142.7357025,136.8754883,145.9850006,143.3433228z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M198.2418976,134.9065552L198.2418976,134.9065552 c4.7258453,6.4678955,29.5258789,3.7964935,42.072403-4.0758667l-3.39534-5.48452l-2.5090027,4.6402512l-3.9854431-4.3580933 l-1.0323944,6.8886108l-6.9384766-5.0615005l-1.1826782,6.0470047l-4.4276886-5.3436127l-1.6225281,6.6091461 l-6.4967346-5.0637512l-2.5089264,6.8913269c-1.9595337-2.3247223-3.0552063-5.2553558-3.1014252-8.2954102 C200.6048126,129.2830048,198.538147,132.5169373,198.2418976,134.9065552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M200.3085632,113.9577026 c0,1.6862564,2.0666656,6.6091385,5.906601,8.0132294c0.1478882-2.1075287-2.5112915-7.0299225-0.8863831-9.137413 l3.3953247,3.0926132l1.0342865-5.9057388l4.5760651,3.2339096l0.4417725-6.8886108l4.723999,3.0926208v-7.5920029 C211.8231354,102.5670013,202.3752289,111.4267273,200.3085632,113.9577026z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M679.4208374,190.5870056 c-1.9927368-4.4989166-8.1931763-9.9816132-13.6551514-13.356842c2.1315918-4.9928589,5.4572144-12.8936768,8.7786255-21.0744019 c-8.2671509,1.6885071-25.4593506,2.9363403-35.4993286,1.8117676 c18.8953247-17.9971619,58.4592285-55.1183624,71.4503784-71.9913483 c-4.723999,23.0590973-1.1802979,74.8022308,8.2672119,92.7993927 c-10.039978-3.9368591-21.6427002-12.0891571-28.1370239-21.0879974 c-3.8305054,12.9185028-8.5288696,26.9960022-11.130188,32.7585907"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M310.7327271,91.8819122 c1.1802673,5.9061966,1.4741821,10.4051514,5.9042053,12.0918579c4.4277039,1.6885223,14.1713867,5.0614929,20.3718567,15.1862793 c-7.3807678-1.9684296-17.7149963-4.7811279-18.6014404,1.9688797c-0.8423157,6.4235916,2.1154785,6.2340012,7.0868835,7.3098373 c6.4948425,1.4063416,12.6953125,8.9987946,12.9916077,19.1240082 c-5.3164978-3.0930634-12.6972656-5.6239929-17.4212036-5.6239929s-6.0526123,0.842453-7.2328796,6.4660034 c-1.9486389,9.2764435,1.6248779,9.8430023,6.0525818,10.4051514c4.4295959,0.5619965,13.8775024,4.7811127,14.4676208,20.2477417 c-5.0202026-4.2189941-15.0881042-6.5694122-21.2586975-7.5919952c-3.3953552-0.5620728-3.9854736,1.124176-4.4272156,7.0299377 c-0.4446411,5.9057465,0.2938843,7.8745728,6.1980896,9.5608826c5.9065857,1.6885071,12.6972046,5.9057465,14.4676514,14.9045563 c-5.6103516-2.5310059-14.4676514-1.6867065-17.1248779-0.5625458c-2.6568604,1.1246338-4.096405,7.4096069,1.5140076,19.5009918 c12.0747986-3.8943634,24.5349121-6.473114,37.1635437-7.6913757c27.9057312-2.7977448,21.258728-21.3700867,21.258728-50.6171112 c0-29.2465668,61.4099426-61.8661041,154.7091675-113.60923c-22.4389954,54.5540009,8.2676392,49.4925156,25.3901978,43.3068619 c17.124939-6.1879196,57.2789917-21.9344788,88.5752563-34.8706017 c-43.1070557,27.5580025-64.9559937,56.8050652-27.1630249,69.7407379 c-48.4212036,14.6223755-70.8602295,54.5540009-44.2874146,79.863739 c-18.1203613-6.1130066-43.2322388,5.4204102-53.7495117,21.4825439 c18.8953247-1.6889954,55.5200195,2.7025299,77.9589844,8.8881836 c21.3672485,5.8903961,56.6400146-1.0072327,59.9637451-19.1569977c0.1755981-0.9154663,0.2654419-1.8453217,0.2683105-2.7774658 c0-6.3269958-1.6291504-11.1040802-4.1243286-14.5850067c-5.4875488-7.6601257-15.104248-9.3179932-20.3812866-9.3179932 c-7.677063,0-15.6484375,3.0926056-15.6484375,8.436264s4.723999,7.592453,14.171875,7.592453 c5.1657104,0,13.1300049,0.8550873,21.8578491-6.7107849c2.4951782,3.4808807,4.1243286,8.2579956,4.1243286,14.5850067 c-0.0078125,0.9194489-0.1015625,1.8361664-0.2801514,2.7381439c-8.2606201,4.4595337-17.4971924,6.8035736-26.8847046,6.8227386 c-18.895813,0-36.6085205-7.3121033-36.6085205-26.9960022s21.2563477-30.9332886,38.3813477-30.9332886 c23.6192627,0,56.6864624,8.9988098,56.6864624,44.9931488c0,45.5579224-62.713501,66.8638916-99.9163818,66.8638916 c6.2374268,4.9842834,13.2617798,9.6268616,20.7908936,12.4377441 c26.3481445,9.8430481,49.6019897,21.9344788,57.8691406,40.4960022c-10.0380249,0-26.5728149-7.874176-34.2498169-15.7488098 c21.258667,24.7476196-4.5249023,70.2698669-1.7704468,85.4895325 c2.9507446,16.3086548,23.0291138,6.1856079,23.0291138,18.8414307c0,11.2471619-11.810791,9.278717-16.2385254,4.2172241 c-4.4300537-5.0614929-18.6270142-9.3139343-25.982666-4.2172241c-6.4943848,4.4993896-16.5319214,6.7481995-20.9619751,2.2488098 c-4.4276733-4.4994202-20.6661987-2.8131409-27.4568481,3.3747559 c-6.7906494,6.1856689-16.2755127,6.6687622-19.1915283,1.9689026 c-3.1223145-5.0330505-2.3240967-11.1528015,10.3062744-13.2711182 c-5.6103516-5.625824-22.7072754,3.9901428-25.6584473-6.6949158 c-2.1226196-7.6782532,2.3610229-11.2494202,17.1225586-10.1252441 c-1.4765015-3.6546936-12.3986206-5.3414001-10.9244385-12.9356689 c1.4765015-7.5924683,10.0100708-12.2923279,20.0784302-1.124176 c26.8662109,29.8086548,39.2672119,13.2178345,48.4188232,0.2821655 c-2.9511719-6.7504578,0.2962646-11.2494202,5.9066162-15.4666443c-2.953064-4.7815552-1.1826172-11.5293274,0.8839722-16.0287781 c-4.4276733-2.5310059-7.0845337-13.7803345-2.3605347-17.7171936c-3.8399048,0-9.7441406-4.2194824-9.7441406-11.5293579 c-5.2670288,3.2019348-12.0204468,2.5129395-16.5324097-1.6866455 c-5.6102905,3.0930481-20.3718872,3.6550903-26.8685913-3.0948792c-8.8577881,3.3747864-24.5061646,2.5305176-28.637146-3.9373169 c-7.7955322,1.9707031-22.1451111-4.4994202-25.096283-11.5293274c-4.5541992-0.3306885-8.9768982-1.6751404-12.9446411-3.9349976 c-11.8084717,8.4367065-27.7995605,24.7453613-11.8572693,37.118988 c15.9446411,12.3735657,49.0113525,2.2483521,49.6019897,33.1816101 c-7.6774902-6.1856689-21.848877-4.4993896-26.5728149-10.6849976 c-15.9422607,22.496521-38.9714355,43.0246887-72.9249878,51.4609375 c5.0178833,3.0930481,14.171875,3.3752441,17.7131653,3.0930481c7.3622742-0.584198,13.5812378,5.3436584,7.9732666,12.3735657 c-5.6103516,7.0321655-17.1249084,1.1246338-23.9154968-4.7792969 c-9.7721558-8.5003662-16.2385559-3.6569519-18.8958435-1.6885071c-2.6567993,1.9684448-6.2005005,3.0953064-10.9239197-1.4063416 c-4.723999-4.4993896-9.1539917-1.4040833-11.5146179,1.4063416c-3.8375549,4.5698242-12.6953125-5.9057617-26.8666992,6.4678345 c-6.8138428,5.9500122-23.0291443-1.6862488-16.53479-10.4051514c-6.7906189,1.6889954-18.8005371-7.706665-8.8572998-16.8707275 c9.153595-8.4362488,26.5723572,10.9671936,40.7442017,5.3414001c-3.184845-3.8601074-9.8228455-11.0110779-23.619751-12.6535034 c-7.0868835-0.8442688-8.341095-8.694519-5.0197449-14.3424683c4.1333313-7.0299377,16.8305664-2.2483521,25.3920593,8.7189026 c6.7441711,8.6394348,15.6483765,8.7166443,24.7995605,7.0299072c6.4299011-4.0827026,16.3869019-4.2194824,20.8165283-2.8126831 c0-4.2172241,6.9365845-7.8746338,12.2506714-7.8746338c-0.2938843-5.6235657,1.4765625-10.6850586,10.0404053-12.0914001 c0.7129211-0.1169434,1.4509277-0.2316589,2.2126465-0.2997742c-5.9648438,0.272644-11.7466125-2.0977783-15.8033752-6.479126 c-11.8269958,2.8858032-24.9294434-2.6759033-26.8548279-13.3126526 c-18.694397-1.303009-20.553009-20.1665039-15.946991-26.3080139c0.3751831-0.5074768,0.7966614-0.9790344,1.2590027-1.4085999 c-5.5639038,4.1838684-12.6740112,6.1193542-21.4668274,3.0727844 c-8.2651367,11.2356567-22.6502686,16.1397095-36.057373,12.2923279 c-3.7171021,5.6180725-9.3790894,9.6644897-15.8981934,11.3618469c0.5508118,6.815918-0.9190979,14.5383911-9.9152832,23.6121521 c2.3605347-12.3739929-14.1718445-16.3108826-10.6281738-36.5568542 c-1.1826477,14.6223755-45.7644043,38.8074646-52.8512878,70.8648682 c6.4967346,2.8126831,13.5836029,4.7793579,18.0113068,3.9368591 c11.1372528-2.1205444,14.7620087,8.9988403,11.5145721,13.4982605s-12.401001,6.7477417-16.2385254,2.8108826 c-3.8375549-3.9350586-11.8108215,1.4063416-15.6483765-5.9039307c-3.8370972-7.3121033-14.4676361-4.7811279-18.8953247,0 c-4.4277039,4.7792969-19.1915894-6.1879272-29.8197632,4.7792969c-3.9764404,4.1025085-17.4187927,8.436676-25.3920746,6.1879272 c-7.9713745-2.2506104-12.6953278-10.1247864-10.0379944-14.3420105 c-5.3140869-4.7815857-5.3880005-10.6367493-0.2938843-15.7488098 c-1.9211426-7.1712341,4.3395233-21.3417053,14.9098816-15.7465515 c6.6427307,3.5138245,30.1876068,20.1069031,50.7078247,1.124176 c17.7918549-16.6635132,7.4272156-30.0158997,18.8213959-31.7770996 c-1.3860016-6.7658386,2.953537-15.1844788,7.6774902-16.8734436c-1.3734131-2.8057251-1.6226807-6.0302429-0.6967926-9.0137024 c-2.6831055-0.2077332-5.3244629-0.7864685-7.8486176-1.7196655c-8.8482666,2.5057983-17.9858246,3.8456726-27.1809998,3.9856262 c0,6.7477417-8.2652435,23.0586243-15.3521271,30.9332886c-2.3610077-61.8660889-61.4104156-68.0544739-69.3836899-117.2648315 c-0.2938766,7.3102875-8.2671585,14.6223755-9.151619,20.8080444c-0.8863907,6.1878662-4.723999,10.9672241-11.8108597,8.1567993 c-7.0845108-2.8132019-8.8572922-14.6246338-1.7704086-16.3109131c7.0868835-1.6885071,5.7582397-12.9361725,10.1859283-14.342453 s5.1661987-5.9057465,3.39534-11.5293274c-1.7727814-5.6235809,0.8844604-12.3735809,2.6572495-16.5908661 c1.7704086-4.2194366-0.8863907-11.2493591-7.0868835-13.7798767c-6.1985931-2.5310059-8.2652588-8.7166138-5.9042282-14.0602722 c-6.4948425-4.4994049-4.6428909-14.2232819,4.1333389-16.0287323 c10.9244385-2.2505951,10.6281815,14.9022522,16.8286591,16.8730011c-0.8840027-3.3748169,0.296257-9.8430634,2.953537-14.0621033 c-3.5436707-7.3125458,0.8863907-13.2160034,7.9708939-13.2160034c12.401001,0,8.2671814,19.6838684,5.3141174,25.8717346 c4.1337738-5.6257629,10.6305237-12.0936279,15.6483459-7.5919952c5.0202026,4.4966888,4.2006531,13.8945618-1.1807556,17.9949036 c-4.4295959,3.3747864-13.5812073,8.7184448-10.923996,14.6241913c5.3140869,8.9987946,8.5610046,19.6838684,9.1535492,33.4642487 c7.3807526,5.3436584,12.1047058,11.5293121,12.1047058,16.5908051c4.8699341,0.2821655,14.1993713,4.131012,15.5,9.5627136 c5.9042664-0.5643616,14.7226563,0.5643311,17.2709351,5.7648926c1.9211273-0.9855652,7.0427551-1.3138123,10.1441956-1.0338745 c0.0104065-4.3926086,1.5376434-8.6468201,4.32341-12.0430908c-10.0375671-10.6873322-9.7436829-27.5579987,0.5906219-34.3080597 c-2.9421539-7.0059967-1.7708893-19.9660034,7.9708862-26.7160034c-0.2104034-7.032196,1.7727966-16.3086853,11.5145874-22.214386 c-1.4765472-7.5942535,3.5436707-17.9971619,9.7441559-18.5597382c-1.477005-7.3119965-0.3611908-16.3370056,8.1998444-20.5565338 c-2.0157928-2.1155548-3.0641327-4.9722595-2.8952332-7.8895264 c-15.0189056,3.0926056-20.8880005,11.8467102-25.6769409,20.0098419 c-0.5901337-3.3752289-1.476532-7.874176-3.5436859-11.2494049c0,8.716629-6.7906189,11.8114929-7.0845032,23.9029083 c-5.0202026-5.0615234-6.7906189-13.2178345-6.4967346-18.8414154c0.2360535-4.5016632-7.6746368-8.7166443-5.3140869-16.5908661 c11.8108368,10.4051971,35.7263641-12.3735428,56.3925934-5.0614319 c-20.372345-40.7759094-35.1338654-21.0925293-45.4681549-14.0603104 c-10.334259,7.0303802-17.7149963-3.3747787-16.5323944-10.1248322 c-13.8775024-3.0930023-30.4122772-2.5309219-48.4212189,0.8442612 c13.2850037-16.5930023,44.5817413-23.9033127,67.6109161-22.2165985 c10.0375671-17.7154388,22.1446381-15.1844711,33.9530945-13.4981995 c7.7210999,1.1047134,16.7385864,1.1286926,25.6864319,0.6988907c5.6103516-14.9045601,38.3813171-16.4454498,41.6305847-28.257 c2.953064,2.2487984,1.1594238,10.7117004-1.7936401,18.0214996c8.5359192-2.4334488,15.8659363-5.0325394,18.3260498-10.146862 c1.476532,4.7793198-0.8840027,17.7149963-4.1338196,21.6523132c3.3675842-0.8979416,6.8523865-1.2771759,10.3342896-1.1246338 c-10.3342896,5.6235809-23.322998,14.0602798-25.389679,15.4666443c-2.0671692,1.4063492-3.2498169,4.2172318,2.0666809,7.0299225 c-5.9066162,1.1246414-22.4389954,6.7504578-29.2296753,2.2510605"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M86.3454819,167.9496155 c7.822998-5.3436584,18.520401-1.3932495,20.8141098,6.4678345c1.476532,5.0614929-7.4916687,8.8200073-8.2671509,4.078186 C97.8600464,172.1686554,93.5783463,168.2317963,86.3454819,167.9496155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M117.0265198,151.6012573 c9.1051941-2.9828949,18.1639404,3.720993,17.9951935,11.8796692c-0.1089935,5.2511139-9.8323212,6.4019165-9.1468811,1.6492462 C126.7886887,158.7855835,123.8725967,153.8455353,117.0265198,151.6012573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M150.8871918,165.9965363 c8.6842804,3.9567261,10.2025146,14.7876129,4.0736237,20.4902039c-3.946106,3.6704865-11.7226868-2.0059052-7.7330017-4.9377899 C152.5514374,177.6405334,154.1114044,172.1686554,150.8871918,165.9965363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M81.7329178,279.6585693 c7.5774689,5.6547852,18.4417114,2.1431885,21.0847702-5.618988c1.70121-4.9973755-7.0940018-9.1152954-8.0775528-4.4086609 C93.4257202,275.9090881,88.9724274,279.6698914,81.7329178,279.6585693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M135.0586853,393.3784485 c3.1730042-8.657074,14.3102722-11.2891846,20.9345398-6.1152649c4.2631836,3.3332825-0.8034668,11.320343-4.3006897,7.8656616 C147.0245056,390.5192566,141.145401,389.6442871,135.0586853,393.3784485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M125.0970001,416.6619263 c0.5275726-9.1549988,13.4101563-14.9086304,21.2814789-11.6878052 c5.0690613,2.0745239,2.5278778,11.0882263-1.8396149,8.6922607 C138.7132874,410.4721985,129.8578796,411.4663391,125.0970001,416.6619263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M139.0972137,438.2659302 c-3.302887-8.612793,3.5597839-17.3691406,12.1279449-17.3623657c5.5155334,0.0045166,6.9086456,9.2412415,1.9050598,8.6791687 C146.4552307,428.8327942,141.3236237,431.7055359,139.0972137,438.2659302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M277.9594116,430.5768433 c1.1409302-9.1044617-7.6514282-16.1258545-15.9882507-14.2477112 c-5.3671875,1.2104492-4.4973755,10.5045166,0.2359924,8.8643188 C268.5257263,423.0042419,274.2123718,424.6774292,277.9594116,430.5768433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M331.2273254,433.4843445 c-1.9766235-8.9744568,6.1312866-16.7054749,14.6093445-15.5325623 c5.4595947,0.7539978,5.4525146,10.0855103,0.5830078,8.8489075 C339.925354,425.1492004,334.4169312,427.2919006,331.2273254,433.4843445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M464.0558777,431.2909851 c0.7380066-9.1441345-8.3553162-15.8083496-16.6020813-13.5970154c-5.3093567,1.4240112-4.0314331,10.6759949,0.627594,8.8484802 C454.2980042,424.1022339,460.0519409,425.546051,464.0558777,431.2909851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M315.456665,414.4419861 c-1.4119873-9.0687256,8.0358276-16.8747559,16.4257507-15.2237244c5.4022522,1.0646057,3.9413757,10.925293-0.8423157,9.4151001 C324.6590576,406.6161499,319.0254517,408.4437256,315.456665,414.4419861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M327.822998,388.3499146 c0.5275574-9.1549988,11.4311523-14.9925842,19.3024902-11.7695007 c5.0666504,2.0745239,1.5533142,11.4566345-2.8117981,9.0606384 C338.4881592,382.4441833,332.5840149,383.1565857,327.822998,388.3499146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M531.1088867,438.2636719 c-1.9766235-8.9744263,6.1307983-16.7055054,14.6088867-15.5325928c5.460083,0.7562561,5.4530029,10.0877991,0.5834961,8.850769 C539.8064575,429.9307861,534.2979736,432.0734863,531.1088867,438.2636719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M663.0391846,433.9692383 c2.043457-8.9608765-6.0084839-16.7470093-14.4956055-15.6296082c-5.4624634,0.71875-5.5245361,10.050293-0.6480103,8.8443909 C654.4037476,425.5772095,659.8984375,427.755127,663.0391846,433.9692383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M514.1157227,417.4646606 c-1.3907471-9.0715027,7.204895-16.3109131,15.5905762-14.6400146c5.3994141,1.0758667,4.7841797,10.389801,0.0066528,8.8665161 C523.3366089,409.6608582,517.6987305,411.4750061,514.1157227,417.4646606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8102E",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M519.0292969,392.70401 c0.1782227-9.1685486,9.8967896-14.9772339,17.8842773-12.0278015c5.1425171,1.8984985,2.9464111,10.9916687-1.5092163,8.7496033 C529.4607544,386.4320068,523.5892334,387.3494568,519.0292969,392.70401z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M552.2424927,93.2887115 c-22.4390259,7.312088-109.2415161,39.9316254-125.1837158,44.9931183s-24.2094727,6.1879272-33.6573486,26.9960022"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M510.3175049,69.1031799 c-56.6860046,34.8705902-102.7442932,65.241333-115.7358704,93.9257813 c-12.9910889,28.682724-12.1047058,46.1177979-43.6972656,51.179245"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M259.95047,268.2019958 c14.1718445-15.7483521,43.6953735-34.8701477,72.0386047-35.9943085 c-5.525238,8.554718-10.2683716,17.5899048-14.1718445,26.9959869"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M317.2270813,269.8886414 c7.0868835-8.9987488,24.7995911-28.1200867,36.0202332-35.9947205 c-5.3140869,15.1867218-14.1713867,51.1809998-9.4474182,75.9263916 c2.9506836-23.6207275,15.941803-60.1775818,29.5234985-80.9878845 c10.0399475,23.0590973,23.6192932,55.6804504,23.6192932,76.4907532 c2.953064-24.7471619-2.9511719-67.4919434-11.8084412-86.051178 c24.2094116,11.8092346,54.3254395,45.5552063,67.3165588,66.365509 c-8.8572998-29.2470093-38.9732971-64.6792603-54.9179077-75.9286499 c39.5638733,6.75,96.842865,30.9350739,118.0987549,48.9326782 c-34.8376465-30.9333038-77.3546448-55.1183777-107.4682922-66.3677826 c47.2385559-3.9351044,135.8138733,6.1879272,161.20401,15.7488098 c-37.2009888-20.2482605-113.9654541-30.9332733-160.0237427-28.1205902 c48.4212646-19.6857147,134.633606-42.1822357,204.3111572-51.7431335 c-53.1451416,2.8108368-121.6424561,16.3108978-191.9101563,31.4953766 c31.2962952-20.2482147,128.1368408-58.491333,151.1660156-65.2413406"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M274.1223145,79.790451 c4.2167969-13.2728729,21.4227295-16.7957306,35.4068909-20.7859192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M297.445343,89.6335602 c-11.8084412-0.8442535-13.9078369-4.841156-7.3812256-9.2809982c4.1338196-2.8126907,12.6953125-7.3121033,18.6019897-7.8741837 c-1.4769897-0.2799225-5.6103821-1.4063492-7.6775208-1.6862564c6.2005005-2.5309982,16.53479-6.1879196,20.0760803-9.5631485"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M283.7157288,68.2611771 c-4.5177612,0.3900681-9.2601929,0.7494507-14.0234985,0.9787903"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M253.1598663,134.3445129 c-2.8809052,0.1436157-5.7467651,0.5055389-8.572937,1.0826416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M205.1386871,277.7145386 c-0.1144257,8.0885925,2.796051,15.9283752,8.1609955,21.9827881c4.723999,5.0614929,33.6596985,6.75,34.8399963-2.8126831"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M209.4620972,265.6714478 c10.0379944,10.6850586,42.5150909,4.2171936,42.5150909-3.6551514"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M210.0527191,231.3633881 c3.5431976,8.436264,41.3343658,16.028717,41.924469,6.1856537"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M218.0236053,204.6473389 c0.2962646,9.8430634,34.7124786,16.2359467,35.7263641,8.9987946"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M229.5381927,182.4329987 c1.476532,7.5919952,24.211792,14.9045563,27.4592133,11.5293121"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M239.2823334,163.8732147 c1.076004,5.3328857,17.418808,10.1230011,23.0291595,8.1545868"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M247.482193,143.3166809 c3.3493347,3.8732147,9.8484344,7.4777832,21.0297699,9.3071747"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M190.8630066,103.4116364 c0.2938843-5.9057007,6.1981354-6.7481613,5.3140869-12.6539001"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M252.8635864,127.5967712 c2.0666656,3.0926056,7.3807373,9.5608826,7.9708862,14.3419952c2.9535522-2.2505951,5.3140869-7.0322266,6.2005005-9.2805634 c2.8197632,2.3450012,4.8755493,5.4781647,5.9042053,8.9983978c1.1831055-3.3747864,3.2497864-9.2805328,3.5436707-12.9356689 c4.2288513,0.9376831,8.1750183,2.8649445,11.5145569,5.6235657c0.5901489-3.6551361-1.1802673-8.4362717-4.1338196-10.4051514 c3.2636414,0.1356201,6.5099487-0.5407333,9.4479065-1.9684296c-2.0666809-2.8108902-5.3140869-6.4678268-8.5615234-8.154541 c2.9535522-0.8442688,7.0849915-4.2167892,8.8577576-5.6236267c-2.6572876-1.1241684-7.3807678-3.6569977-10.334259-5.0614395 c1.770874-1.6885223,3.2473755-5.060997,4.1337891-7.5942612"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M203.8517609,81.9002533 c-1.9183044,0-2.8047028,4.2172394,0.7384949,6.889061c2.5482941,1.9223404,2.5089264,9.8430557-2.0666656,11.8115005"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M272.9391785,141.6566162 c-12.988739,28.6826782-24.9474487,83.0976257-20.8141174,122.4671631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M266.1485596,317.9766541 c0,5.906189,9.7441711,7.030365,9.4479065-7.0299072"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M274.7124634,317.9766541 c1.1802673,5.0614929,11.2183228,6.1860962,9.1511841-8.7184448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M270.5786438,321.9140015 c0.5901489,10.9672241,7.9708862,10.4051514,8.5610046,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M284.1599121,314.3197021 c2.9511414,6.75,11.2182922,3.3747864,8.8577271-11.5293274"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M293.3115234,309.2582092 c3.2493286,5.625824,10.9244385,1.1264343,11.8108215-8.7166443"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M254.9302673,278.0450134 c-5.0661926,5.2839966-10.878006,17.1465759-3.8394623,28.4023132 c4.1357422,6.606842,15.5024261,10.2642822,16.6826935,6.3269348"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M251.0908051,306.4473267 c-4.5760651,0.7033997-11.3064728,10.0457764-7.9713745,18.9804688 c2.3634033,6.3269958,15.9446259,10.1252441,18.0113068,5.4849854"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M389.8581848,314.3197021 c14.7615051,1.6885071,34.2493591-7.8723755,35.4301147-26.9960022"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M423.5150146,296.3225098 c8.2676086,5.0615234,25.3925476,6.75,32.4770813-6.1860657"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M431.1925049,300.2593689 c-7.6774902,16.8729858-14.6321106,34.7997131,1.1802673,47.8063049 c12.9911194,10.6873169,22.6404724-5.2443542,38.3836365,10.6873169 c4.7234802,4.7793274-0.8868713,13.7776794-48.4216919,39.9316406"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M194.9945068,278.7484436 c3.1013947,6.3265076,2.8051453,18.7005615-3.0990906,17.0115662"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M148.345993,418.6506653 c10.0379944-14.6223755,21.8905792-2.806366,30.4099274-5.3436584"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M226.7353821,84.4290009 c-1.7727814,4.0781708,2.9416962,9.7834702,7.3807678,10.2660904c5.1661987,0.562088,12.5469971-2.6718292,10.9244385-7.8741837"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M221.5673218,84.8519974 c2.6567841-3.5160904,33.6592255,7.5924606,46.0582581-0.2821808"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M121.1830826,189.7449951 c-1.1802597,2.528717-0.737999,9.9821167,3.8399277,14.0603027"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M340.2561951,416.3996277 c2.3630066-2.8104248,11.105011-5.6497498,17.5671692-4.0759277c6.3483582,1.5454102,17.7150574-0.5620728,25.0958557-3.3752441"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M272.9391785,141.6566162 c-2.9506836,27.5585022,3.6919861,69.8820038,20.6686096,88.7234192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M264.0241089,166.1243134 c0.4858093,24.5223236,6.7905884,53.6370087,19.2541504,69.663559"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M257.2007446,192.8488922 c2.4534607,18.5574951,7.9779968,37.2183075,16.708252,49.3381653"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M252.9214172,221.0155792 c2.9488068,11.0132751,7.1006165,21.1208649,12.4915466,28.7219543"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M251.4008026,247.667511 c1.6592712,3.544632,3.627182,6.9364014,5.8809967,10.1360779"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M272.3490601,158.8099976 c-0.8840027,8.7184448-6.4943848,15.4661865-11.5145874,19.4035034"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M272.9391785,170.9036255 c-0.8840027,8.7161865-7.0845032,16.590744-15.2037659,20.3868103"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M274.7124634,182.9949951 c-0.8863831,8.7166138-9.7441406,19.4035034-19.782196,24.1828156"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M277.072998,195.0864563 c-0.8840027,8.7188721-12.3985901,21.934433-24.1217041,26.1760864"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M280.7645569,207.1778564 c-3.3953247,11.8119507-16.9765625,25.5918732-28.9333649,28.6849365"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M286.0786743,219.2720032 c-0.8863831,8.7161865-19.0437012,26.4334259-34.6915741,31.4949036"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M177.7235565,272.983551 c1.9187775,8.0132446-4.4295959,15.3257751-7.677002,13.356842"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M211.5292511,300.8237305 c-30.7061615-6.1878662-53.5366974-16.4960022-66.1343689-40.4959412 c-3.2493134-6.1856537,5.3140869-7.874176,4.723999-13.497757"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M140.9652863,213.3657837 c-5.3140869-8.9983521-6.4967041-18.8414154-3.5436401-25.0271301"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M162.2235413,263.4208374 c0,5.0632935-6.3483734,11.5293274-8.5634155,9.139679"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M213.2996674,299.6973267 c-3.5389252,8.1874695,3.3052521,23.8216553,18.3236847,29.1982727"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M243.1194305,325.4277954 c-1.7722168,1.262207-3.0593109,3.0926819-3.6474762,5.187439"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M255.2265472,342.1599426 c-2.6591797,4.2194824-12.9911346,1.1264343-15.0578003-2.5310059"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M213.6698608,388.27948 c-12.5189972,11.7234497-25.2716675,12.3848572-40.5218811,14.0603027 c-15.3540039,1.6885071-19.6338043-4.9206238-25.0958099,0.5621033"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M313.6833801,300.2593689 c1.7732544,7.8746948,1.1807556,15.7488708-5.9042053,27.5603638c-3.911499,6.5166016-0.205719,13.5464783,0.4678345,21.943512"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M381.6692505,323.0362854 c6.7678528-5.0881348,11.234436-13.4805603,13.5030518-19.9637451"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M360.2024231,326.1090698 c7.7003174-10.0345764,8.9019775-23.6174011,3.0829468-34.8479919"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M324.1452026,338.4013977 c4.5386047-6.6749878,7.2537231-16.183136,7.2537231-28.5810852"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M232.4912567,356.5024109 c1.1807556,5.7644348,10.3342896,8.2953491,11.8108368,5.4845276"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M305.7124939,288.7301025 c0,5.6235657-5.9042358,9.8430786-10.3342896,6.4678345c0.5901489,8.154541-5.6080017,10.6873169-10.0375671,6.7504578 c0.8864136,11.5293274-9.1516418,12.6535034-15.6483765,3.6546936 c-7.3807678,34.5884094-32.1808014,60.4597473-33.9535828,77.3327332 c-0.5901337,3.9373169-16.3864136,2.8131409-12.2530823-8.7161865"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M412.8873291,320.5076294 c-8.8577576-1.0537415-24.4364319-3.6461182-31.2180786,2.528656"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M416.4305115,346.9414978 c-8.1860962,3.0925903-14.8008728,4.1797485-20.0732117,3.8113403"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M439.0155334,370.5446167 c8.1585999-0.3042908,16.5737-5.4714661,19.9300842-18.2594604"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M423.2121277,364.0655212 c6.8458252-1.6263428,12.6586609-6.1240845,15.9512939-12.3425293"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M463.3728333,373.3753662 c-5.1401062-1.5476379-15.9906006-3.5892334-24.3572998-2.8307495"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M434.1455688,392.2167969 c3.247406-1.6885071-2.0666809-9.2810059-7.3831177-9.2810059"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M372.1431274,404.8703003 c7.5181885-3.0706482,14.73349-6.8359985,21.552124-11.2471619"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M414.5117798,390.8104553 c4.0086365,1.2739868,9.8901062,6.1856689,7.822998,7.874176"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M452.4507751,285.6374817 c4.723999,7.874176,13.5793457,12.9356689,25.3901672,7.874176c0.8309326,2.3720093,3.6385193,4.8059387,7.1333313,6.75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M517.6987305,283.6686096 c5.9066162,4.4994202-4.4276733,21.09021-19.7798462,20.5281372"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M600.3674316,385.1868896 c2.0481567,4.6799927,9.7441406,4.2167664,12.6972046,0c3.3720703-4.8190002,9.447876-19.6861267,5.9042358-49.4947815 c-3.5432129-29.8068542-33.6573486-33.7437134-68.4973145-40.4941711 c-34.8400269-6.7477417-43.6972656-17.4350586-50.7817688-37.1184998"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M606.2739868,369.7202454 c2.9511719,4.7793274,11.2183228,3.6551514,12.3986206-1.1264343"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M607.15802,353.6914673 c4.4300537,2.5305481,12.9910889,1.6863098,12.6948242-3.9372559"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M604.7974854,335.9742737 c3.8370972,0,14.1713867,0.5621033,13.5812378-3.9373169"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M595.0533447,324.4448853 c3.2474365-2.2510071,12.401001-11.8114624,7.3807373-14.6246033"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M578.5209351,322.7582397 c5.6079712-3.0948792,11.8084717-19.1235962,5.0178223-20.5299377"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M551.6523438,319.6633606 c8.8572998-3.3752441,17.125-20.8103027,11.2202148-21.9344788"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M523.0151978,315.7260742 c14.465271-3.6551514,18.8953857-22.214386,13.2849731-23.9029236"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M542.7945557,398.9645386 c15.0672607,1.1485596,23.3253784,8.7188416,29.2296753,11.8114624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M539.2532349,246.2674408 c13.7272339-1.2649994,27.2231445,18.7317047,45.9336548,33.680069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M690.6254883,157.6875916 c2.5828247-8.7121277,4.7471313-16.8969116,5.6984863-21.6545563"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M551.3305054,415.7846985 c3.5239868-0.5568542,7.0880737-0.8208008,10.6557007-0.7891846"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M685.1032715,129.2830048 c-1.9951172,5.3834076-6.2839966,16.339798-10.559021,26.8727264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.15651
    },
    d: "M313.7208252,221.8995667 c-26.0404968,8.5509949-53.0067444,24.9697571-70.3051758,55.3012085c9.4479065,2.2488098,27.7531128,0,36.0202637-2.8126831 c0.5906372,7.3121033,0.5906372,16.8729858,0.5906372,23.0609131 c8.2671204-6.1879272,18.3051758-15.1867065,25.9821777-17.4350586 c-0.5924988,7.309845-0.5924988,20.2454529-0.5924988,25.3092346 c11.2207031-11.2494202,32.4770813-12.3735657,38.3836365,4.4971619 c4.7234802-24.7453613,43.6948853-25.8695374,53.1427917-4.4971619 c10.6305542-19.6856689,37.7929993-26.99823,55.5080872-19.6856689 c7.6751099-20.8103027,41.332428-32.0574646,63.1808472-26.9960022 c-7.2419128-9.5343018-5.947876-20.0762329-0.0137939-29.1363983"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      strokeWidth: 1.69161,
      strokeLinejoin: "round"
    },
    d: "M230.2288971,85.3907776l11.5809937,2.0395813 C241.8098907,87.4303589,233.6588745,97.8336105,230.2288971,85.3907776z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWales);
export default __webpack_public_path__ + "static/media/wales.4a42ac30b172bcacbef4815525e22ff9.svg";
export { ForwardRef as ReactComponent };